<template>
  <div>
    <div class="custom-card">
    <page-header
      title="Pricing & Collections"
      :back="{ path : '/3pl/dashboard'}"
      breadcrumb="Dashboard > Settings > Pricing & Collections"
    />
  
      <m-tab
        :tabs="tabs"
        :current-tab="currentTab"
        @current-tab="currentTab = $event"
      />
      <Pricing v-if="currentTab === 'pricing'">
        pricing
      </Pricing>
      <Collections v-else>
      </Collections>
  </div>  
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import MTab from "@/components/UI/MTab.vue";
import Pricing from "./Pricing/Pricing.vue";
import Collections from "./Collections/Index.vue";

export default {
  components: {
    PageHeader,
    MTab,
    Pricing,
    Collections
  },
  data() {
    return {
      tabs: [
        { id: "pricing", value: "Pricing" },
        { id: "collections", value: "Collections" },
      ],
      currentTab: "pricing",
    };
  },
};
</script>

<style>
</style>